const initialState = {
    count: 0,
  };
  
  export const holdOrdersCountReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_HOLD_ORDERS_COUNT":
        return { count: action.payload };
      case "INCREMENT_HOLD_ORDERS_COUNT":
        return { count: state.count + 1 };
      case "DECREMENT_HOLD_ORDERS_COUNT":
        return { count: Math.max(0, state.count - 1) }; 
      default:
        return state;
    }
  };